var lib_core         = require("lib-core");
var lib_geometry     = require("lib-geometry");
var THREE                    = require("three");
var CanvasRenderer                    = require("./canvasRenderer");

var Editor3DView = function (parentTemplate, mode, root, stateMachine, editorModel, layers, layerOptions, heavyHandler, config) {
    var self = this;

    this.root               = root;
    this.mode               = mode;
    this.stateMachine       = stateMachine;
    this.editorModel        = editorModel;
    this.data               = root.data;
    this.heavyHandler       = heavyHandler;

    this.config = config;

    // PARENT TEMPLATE
    this.parentTemplate = parentTemplate;

    // BIND OUR EVENT LISTENERS
    if(!this.config.disableMouse)
        this.initEventListeners();

    // DISABLE RIGHT CLICK
    this.getTemplate().getCanvasEl().bind('contextmenu',function() {return false;});

    this.getTemplate().getCanvasEl().bind('dragover', function() {return false;});


    ////////////////////////////////////////////////////////////////
    //    RENDERER
    ////////////////////////////////////////////////////////////////

    // threeJS nevessities
    this.rootGroup = new THREE.Group();
    this.guiGroup = new THREE.Group();

    this.threeScene = new THREE.Scene();
    this.guiScene = new THREE.Scene();

    this.usingCanvas = false;
    if ( this.webglAvailable() ) {
        this.renderer = new THREE.WebGLRenderer({antialias: true, alpha: true});
    } else {
        this.renderer = new CanvasRenderer({antialias: true});
        this.usingCanvas = true;
    }

    this.raycaster = new THREE.Raycaster();
    this.rayMouse = new THREE.Vector2();
    this.hoveringMesh = null;
    this.hoveringMeshPoint = null;
    this.ray = null;


    // VIEWS TO REGISTER (needed by rendering and/or raycasting)
    this.cameraView = null;
    this.handleViews = new lib_core.Collections.HashSet();

    // MESH TO INTERACTION MAP  (FOR RAYCAST)
    this.meshToInteractionMap = new lib_core.Collections.HashMap();

    // IMPORTANT LISTS
    this.selectableMeshes = new lib_core.Collections.HashSet();
    this.guiMeshes = new lib_core.Collections.HashSet();

    this.threeScene.add(this.rootGroup);
    this.guiScene.add(this.guiGroup);

    // this may come back in the future, once the camera has improved and can be scaled with the world
    // var matrix = new THREE.Matrix4();
    // matrix.makeScale(this.editorModel.worldScale, this.editorModel.worldScale, this.editorModel.worldScale);
    // this.rootGroup.matrix = matrix;

    this.rootGroup.matrixAutoUpdate = false;
    this.guiGroup.matrixAutoUpdate = false;

    //////////// TODO: this below should come from model properties that are set by config

    for(var i = 0; i < this.config.lights.length; i++){

        var light;
        var lightinfo = this.config.lights[i];
        if(lightinfo.type == "directional"){
            light = new THREE.DirectionalLight( lightinfo.color );
            light.position.set( lightinfo.position[0], lightinfo.position[1], lightinfo.position[2] );
            light.intensity = lightinfo.intensity;
            this.threeScene.add( light );
        } else if(this.config.lights[i].type == "ambient"){
            light = new THREE.AmbientLight( lightinfo.color );
            light.intensity = lightinfo.intensity;
            this.threeScene.add( light );
        }
    }

    this.guiScene.add(new THREE.AmbientLight(0xffffff));

    this.renderer.setClearColor( this.config.clearColor );
    this.renderer.sortObjects = false;

    /////////////////

    this.canvasWidth = this.getTemplate().getCanvasEl().width();
    this.canvasHeight = this.getTemplate().getCanvasEl().height();


    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize(  this.canvasWidth, this.canvasHeight , false);
    this.renderer.autoClear = false;

    this.container = this.getTemplate().getCanvasEl()[0];

    this.container.appendChild( this.renderer.domElement );

    this.editorModel.canvasRect.onChange("3dResizeView", function(){

        self.canvasWidth = self.editorModel.canvasRect().width;
        self.canvasHeight = self.editorModel.canvasRect().height;

        self.onWindowResize();

    }, 10);

    //todo should go in abstractEditorView
    $(window).resize(function(event){
        self.onResize();
    });

    this.renderWaiting = false;

    if(this.usingCanvas){

        var str1 = 'There is a problem running WebGL on this machine.';
        str1 += '  As a result, packages will be rendered as wireframes, and large components may slow down performance.';

         var error = new Error(str1);

        var str2 = 'For more information on WebGL, visit <a href="https://get.webgl.org/" target="_blank">WebGL.org</a> ';
        str2 += 'or check your graphics card compatibility.  For Windows machines, a suggested workaround is described on the';
        str2 += ' <a href="https://forums.autodesk.com/t5/eagle-forum/trouble-in-lunching-package-generator-in-eagle-8-7-1/m-p/7892926/highlight/true#M11665/" target="_blank">EAGLE forum</a>.';
        lib_core.logError("Webgl Error", error, lib_core.logError.criticality.MAJOR, str2, true);
    }
};

module.exports = Editor3DView;

//todo should go in abstractEditorView
Editor3DView.prototype.onResize = function() {
    var cEvent = new lib_core.GuiEvent()
        .type( lib_core.GuiEvents.CANVAS_RESIZE );

    cEvent.element("editorModel", this.editorModel);
    cEvent.data("bb", this.getEditorSize());

    this.stateMachine.handle(cEvent);
};

// took this function from threejs docs
Editor3DView.prototype.webglAvailable = function() {
    try {
        var canvas = document.createElement( 'canvas' );
        return !!( window.WebGLRenderingContext && (
            canvas.getContext( 'webgl' ) ||
            canvas.getContext( 'experimental-webgl' ) )
        );
    } catch ( e ) {
        return false;
    }
}

Editor3DView.prototype.registerCameraView = function(cameraView){
    this.cameraView = cameraView;
};

Editor3DView.prototype.registerHandleView = function(handleView){
    this.handleViews.add(handleView);
};


Editor3DView.prototype.render = function() {
    if(!this.renderWaiting){
        window.requestAnimationFrame(this.renderScene.bind(this));
    }
    this.renderWaiting = true;
};

Editor3DView.prototype.renderScene = function(){
    if(this.cameraView == null){
        this.renderWaiting = false;
        return;
    }

    this.renderer.clear();
    this.renderer.render( this.threeScene, this.cameraView.viewCamera );
    this.renderer.clearDepth();
    this.renderer.render( this.guiScene, this.cameraView.viewCamera );

    this.renderWaiting = false;
}


Editor3DView.prototype.onWindowResize = function() {
    if(this.cameraView == null)
        return;

    this.cameraView.updateAspectRation( this.canvasWidth , this.canvasHeight);

    if(!this.nowebgl)
        this.renderer.setSize( this.canvasWidth , this.canvasHeight);

    this.render();
};

Editor3DView.prototype.getEditorSize = function() {

    return new lib_geometry.BoundingBox(
        this.getTemplate().getCanvasEl().offset().left,
        this.getTemplate().getCanvasEl().offset().top,
        this.getTemplate().getCanvasEl().width(),
        this.getTemplate().getCanvasEl().height()
    );
};

Editor3DView.prototype.relativeMouseCoord = function(event) {
    return this.editorModel.getRelativeMouseCoord(event);
};


Editor3DView.prototype.getTemplate = function () {
    if(!this._template){
        this._template = this.parentTemplate.addEditorHolderTemplate();
    }

    return this._template;
};


///////////////////// To register meshes to the mesh lists (and interaction map)

// add all of the meshes in the group, mapped to one interaction model.
Editor3DView.prototype.addMeshToSelectableList = function(meshOrGroup, interactionModel, isGui){
    var self = this;
     if(meshOrGroup instanceof THREE.Object3D || meshOrGroup instanceof THREE.Group){
        meshOrGroup.traverse ( function(child){

            if(child instanceof THREE.Mesh){
                // we are a mesh
                if(isGui){
                    self.guiMeshes.add(child);
                } else {
                    self.selectableMeshes.add(child);
                }
                self.meshToInteractionMap.put(child, interactionModel);

            } else {
                 // don't add ourself (infinite loop because traverse calls us too)
                 if(child == meshOrGroup) return;

                self.addMeshToSelectableList(child, interactionModel);
            }
        } );
    } else {

        if(isGui){
            self.guiMeshes.add(meshOrGroup);
        } else {
            self.selectableMeshes.add(meshOrGroup);
        }
        self.meshToInteractionMap.put(meshOrGroup, interactionModel);
    }
};


Editor3DView.prototype.removeMeshFromSelectableList = function(meshOrGroup){
    var self = this;
     if(meshOrGroup instanceof THREE.Object3D || meshOrGroup instanceof THREE.Group){
        meshOrGroup.traverse ( function(child){
            if(child instanceof THREE.Mesh){
                 // we are a mesh
                if(self.selectableMeshes.contains(child)){
                    self.selectableMeshes.remove(child);
                }

                if(self.guiMeshes.contains(child)){
                    self.guiMeshes.remove(child);
                }

                if(self.meshToInteractionMap.contains(child)){
                    self.meshToInteractionMap.remove(child);
                }
            } else {
                if(child == meshOrGroup) return; // if me, continue

                self.removeMeshFromSelectableList(child);
            }
        } );
    } else {

        if(self.selectableMeshes.contains(meshOrGroup)){
            self.selectableMeshes.remove(meshOrGroup);
        }

        if(self.guiMeshes.contains(meshOrGroup)){
            self.guiMeshes.remove(meshOrGroup);
        }

        if(self.meshToInteractionMap.contains(meshOrGroup)){
            self.meshToInteractionMap.remove(meshOrGroup);
        }
    }
};


Editor3DView.prototype.destroyObject = function(obj3d){
        if(!(obj3d instanceof Object)) return;
        if (obj3d.geometry) {
            obj3d.geometry.dispose();
        }
        if (obj3d.material) {
            if (Array.isArray(obj3d.materia)) {
                obj3d.material.forEach((material) => { material.dispose(); });
            } else {
                obj3d.material.dispose();
            }
        }
        obj3d.traverse((child) => {
            if(child.isMesh) {
                if (child.geometry) child.geometry.dispose();
                if (child.material) {
                    if (Array.isArray(child.material)) {
                        child.material.forEach((material) => { material.dispose(); });
                    } else {
                        child.material.dispose();
                    }
                }
            }
        })
        obj3d = null;
    }

//////////////////////////////////////////////////////////////

Editor3DView.prototype.doRaycast = function(){
    var self = this;
    if(self.cameraView != null){

        // some magic I guess
        self.rayMouse.x = ( this.mouseCoord.x / this.canvasWidth ) * 2 - 1;
        self.rayMouse.y = - ( this.mouseCoord.y / self.canvasHeight ) * 2 + 1;

        this.raycaster.setFromCamera( this.rayMouse, this.cameraView.viewCamera );

        this.ray = this.raycaster.ray;

        // turn into an array

        var guiElements = [];
        this.guiMeshes.forEach(function(item){
            guiElements.push(item);
        });
        var guiIntersects = this.raycaster.intersectObjects( guiElements );

        if ( guiIntersects.length > 0 ) {
            this.hoveringMesh = guiIntersects[ 0 ].object;
            this.hoveringMeshPoint = guiIntersects[ 0 ].point;
            return;
        }

        // if no gui look for object
        var objects = [];
        this.selectableMeshes.forEach(function(item){
            objects.push(item);
        });
        var intersects = this.raycaster.intersectObjects( objects );

        if ( intersects.length > 0 ) {
            this.hoveringMesh = intersects[ 0 ].object;
            this.hoveringMeshPoint = intersects[ 0 ].point;
            return;
        }

        // else
        this.hoveringMesh = null;
    }
};


Editor3DView.prototype.makeWifreframe = function(threejsObj){
    if(threejsObj.material){
        threejsObj.material = new THREE.MeshBasicMaterial( {
            flatShading: true,
            color: 0xffffff,
            wireframe: true
        });
    }
    for(var i = 0; i < threejsObj.children.length; i++){
        this.makeWifreframe(threejsObj.children[i]);
    }
}


//////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////   ALL OF THE BELOW IS FOR SENDING MOUSE EVENTS TO THE STATE MACHINE
//////////////////////////////////////////////////////////////////////////////////////////////////

Editor3DView.prototype.initEventListeners = function () {
    var self = this;
    this.mousedown_flag = false;

    // EDITOR CONTAINER OBSERVERS
    this.parentTemplate.$el.mousedown(function(event) {
        return self.onEditorMouseDown(event);
    });

    this.parentTemplate.$el.mousemove(function(event){
        return self.onEditorMouseMove(event);
    });

    this.parentTemplate.$el.mouseup(function(event){
        return self.onEditorMouseUp(event);
    });

    // SVG EVENT LISTENERS
    this.getTemplate().getCanvasEl().mousedown(function(event) {
        return self.onCanvasMouseDown(event);
    });

    this.getTemplate().getCanvasEl().mouseup(function(event){
        return self.onCanvasMouseUp(event);
    });

    this.getTemplate().getCanvasEl().mousewheel(function(objEvent, delta, deltaX, deltaY){
        return self.onCanvasMouseWheel(objEvent, delta, deltaX, deltaY);
    });

    // TOUCH EVENTS
    function msieversion() {
        var ua = window.navigator.userAgent;
        var old_ie = ua.indexOf('MSIE ');
        var new_ie = ua.indexOf('Trident/');

        if ((old_ie > -1) || (new_ie > -1)) {
            return true;
        }else{
            return false;
        }
    }

    if(window.navigator.msPointerEnabled && msieversion() ){
        // TODO: to be updated
        // Hammer(this.getTemplate().getCanvasEl().get(0)).on("transformstart", function(event) {
        //     var cEvent = new lib_core.GuiEvent()
        //             .type( lib_core.GuiEvents.EDITOR_TRANSFORM_START )
        //             .fromJSEvent(event);

        //     self.stateMachine.handle(cEvent);

        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0)).on("transform", function(event) {
        //     var cEvent = new lib_core.GuiEvent()
        //             .type( lib_core.GuiEvents.EDITOR_TRANSFORM )
        //             .fromJSEvent(event);

        //     self.stateMachine.handle(cEvent);

        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0)).on("transformend", function(event) {
        //     var cEvent = new lib_core.GuiEvent()
        //             .type( lib_core.GuiEvents.EDITOR_TRANSFORM_END )
        //             .fromJSEvent(event);

        //     self.stateMachine.handle(cEvent);

        // });

    }else if ('ontouchstart' in document.documentElement) {

        // Hammer(this.getTemplate().getCanvasEl().get(0),{"prevent_default":true}).on("transformstart", function(event) {
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_TRANSFORM_START)
        //             .fromJSEvent(event);

        //     return self.stateMachine.handle(cEvent);
        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0),{"prevent_default":true}).on("transform", function(event) {
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_TRANSFORM)
        //             .fromJSEvent(event);

        //     return self.stateMachine.handle(cEvent);
        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0),{"prevent_default":true}).on("transformend", function(event) {
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_TRANSFORM_END)
        //             .fromJSEvent(event);

        //     return self.stateMachine.handle(cEvent);
        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0),{"prevent_default":true}).on("dragstart", function(event) {
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_TOUCH_PAN_START)
        //             .fromJSEvent(event);

        //     return self.stateMachine.handle(cEvent);
        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0),{"prevent_default":true}).on("drag", function(event) {
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_TOUCH_PAN)
        //             .fromJSEvent(event);

        //     return self.stateMachine.handle(cEvent);
        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0),{"prevent_default":true}).on("dragend", function(event) {
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_TOUCH_PAN_END)
        //             .fromJSEvent(event);

        //     return self.stateMachine.handle(cEvent);
        // });

    }
};

/**
 * @param   {Object}    event
 * @return  {boolean}
 * @this    {SchematicEditor}
 */
Editor3DView.prototype.onEditorMouseUp = function(event) {
    this.mousedown_flag = false;
    var mouseCoord = this.relativeMouseCoord(event);
    this.mouseCoord = mouseCoord;

    var jqueryEventMin = {};
    if( event.clientX !== undefined )  jqueryEventMin.clientX = event.clientX;
    if( event.clientY !== undefined )  jqueryEventMin.clientY = event.clientY;

    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_MOUSE_UP)
            .fromJSEvent(event)
            .data('jsEvent', jqueryEventMin)
            .data( 'mouseCoord', mouseCoord )
            .scope(this.editorModel.scope());

    this.stateMachine.handle(cEvent);
};

/**
 * @param   {Object}    event
 * @return  {boolean}
 * @this    {SchematicEditor}
 */
Editor3DView.prototype.onEditorMouseDown = function(event){
    this.mousedown_flag = true;
    var mouseCoord = this.relativeMouseCoord(event);
    this.mouseCoord = mouseCoord;

    var jqueryEventMin = {};
    if( event.clientX !== undefined )  jqueryEventMin.clientX = event.clientX;
    if( event.clientY !== undefined )  jqueryEventMin.clientY = event.clientY;

    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_MOUSE_DOWN)
            .fromJSEvent(event)
            .data('jsEvent', jqueryEventMin)
            .data( 'mouseCoord', mouseCoord )
            .scope(this.editorModel.scope());

    this.stateMachine.handle(cEvent);
};

/**
 * @param   {Object}    event
 * @return  {boolean}
 * @this    {SchematicEditor}
 */
Editor3DView.prototype.onEditorMouseMove = function(event){
    this.mouseCoord = this.relativeMouseCoord(event);

    // Track Cursor
    if (this.root.shareJsDoc && this.root.shareJsDoc.connection && this.root.shareJsDoc.connection.id && window["users"] > 0) {
        // Make sure we still exist in the doc and we are not too old
        var rec = this.root.shareJsDoc.at(["users", this.root.shareJsDoc.connection.id]).get();
        var d = new Date();
        d.setMinutes(d.getMinutes()-5);

        if (!rec || rec.last_active < d) {
            this.root.shareJsDoc.at(["users", this.root.shareJsDoc.connection.id]).set({'name': $(".username_holder").text(), 'last_active': Date.now()});
        }

        // Send my position around
        this.root.shareJsDoc.shout(JSON.stringify([this.root.shareJsDoc.connection.id, "mousePos", this.editorModel.toRealCoord(this.mouseCoord), this.editorModel.type()]));
    }

    // on mouse move do a raycast :)
    this.doRaycast();

    var jqueryEventMin = {};
    if( event.clientX !== undefined )  jqueryEventMin.clientX = event.clientX;
    if( event.clientY !== undefined )  jqueryEventMin.clientY = event.clientY;

    var rayData = {};
    rayData.origin    = {x: this.raycaster.ray.origin.x    , y: this.raycaster.ray.origin.y    , z:this.raycaster.ray.origin.z    };
    rayData.direction = {x: this.raycaster.ray.direction.x , y: this.raycaster.ray.direction.y , z:this.raycaster.ray.direction.z };


    if(this.hoveringMesh != null){
        var hoveringElementModel = this.meshToInteractionMap.get(this.hoveringMesh);

         var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_MOUSE_MOVE)
                .fromJSEvent(event)
                .element(hoveringElementModel) // assuming ok, editor2d does this too
                .data('jsEvent', jqueryEventMin)
                .data('mouseCoord', this.mouseCoord )
                .data('ray', rayData )
                .data('type', this.editorModel.type())
                .scope(this.editorModel.scope());

        this.stateMachine.handle(cEvent);


    } else {
        // Inject event
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_MOUSE_MOVE)
                .fromJSEvent(event)
                .data('jsEvent', jqueryEventMin)
                .data('mouseCoord', this.mouseCoord )
                .data('ray', rayData )
                .data('type', this.editorModel.type())
                .data('canvasWidth', this.canvasWidth)
                .data('canvasHeight', this.canvasHeight)
                .scope(this.editorModel.scope());

        this.stateMachine.handle(cEvent);
    }

    // This is used to prevent dragging selection
    return false;
};

/**
 * @param   {Object}    objEvent
 * @param   {number}    delta
 * @param   {number}    deltaX
 * @param   {number}    deltaY
 * @return  {boolean}
 * @this    {SchematicEditor}
 */
Editor3DView.prototype.onCanvasMouseWheel = function(objEvent, delta, deltaX, deltaY){
    this.mouseCoord = this.relativeMouseCoord(objEvent.originalEvent);

    var intDelta = (objEvent.shiftKey) ? -deltaX : deltaY ;
    if ( Math.abs(intDelta) >= 40 ) {
        intDelta /= 40;
    }

    var eventInfo = {
        wheelDelta: delta
    };

    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CANVAS_MOUSE_WHEEL);
    cEvent
        .data( 'intDelta', intDelta )
        .data('jsEvent', eventInfo)
        .data( 'mouseCoord', this.mouseCoord )
        .scope(this.editorModel.scope());

    return this.stateMachine.handle(cEvent);
};

/**
 * @param   {Object}    event
 * @return  {boolean}
 * @this    {SchematicEditor}
 */
Editor3DView.prototype.onCanvasMouseUp = function(event) {
    this.mousedown_flag = false;
    var mouseCoord = this.relativeMouseCoord(event);
    this.mouseCoord = mouseCoord;

    var jqueryEventMin = {};

    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CANVAS_MOUSE_UP)
            .fromJSEvent(event)
            .data('jsEvent', jqueryEventMin) //definately not ok
            .data( 'mouseCoord', mouseCoord )
            .scope(this.editorModel.scope());

    return this.stateMachine.handle(cEvent);
};

/**
 * @param   {Object}    event
 * @return  {boolean}
 * @this    {SchematicEditor}
 */
Editor3DView.prototype.onCanvasMouseDown = function(event){
    this.mousedown_flag = true;
    var mouseCoord = this.relativeMouseCoord(event);
    this.mouseCoord = mouseCoord;

     var jqueryEventMin = {};
    if( event.clientX !== undefined )  jqueryEventMin.clientX = event.clientX;
    if( event.clientY !== undefined )  jqueryEventMin.clientY = event.clientY;
    if( event.button  !== undefined )  jqueryEventMin.button  = event.button;

    var rayData = {};
    rayData.origin    = {x: this.raycaster.ray.origin.x    , y: this.raycaster.ray.origin.y    , z:this.raycaster.ray.origin.z    };
    rayData.direction = {x: this.raycaster.ray.direction.x , y: this.raycaster.ray.direction.y , z:this.raycaster.ray.direction.z };

    var cEvent;

    // no element down in view mode
    if(this.hoveringMesh != null && !this.config.canNotSelect){

         var hoveringElementModel = this.meshToInteractionMap.get(this.hoveringMesh);

         if(!hoveringElementModel.selectable || hoveringElementModel.selectable()){
             cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
            .fromJSEvent(event)
            .element(hoveringElementModel) // assuming ok, editor2d does this too
            .data('ray', rayData )
            .data( 'mouseCoord', mouseCoord )
            .data( 'mousePoint', {x: this.hoveringMeshPoint.x, y: this.hoveringMeshPoint.y, z: this.hoveringMeshPoint.z})
            .scope(this.editorModel.scope());
            return this.stateMachine.handle(cEvent);
         }

    }

    cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CANVAS_MOUSE_DOWN)
        .fromJSEvent(event)
        .data('jsEvent', jqueryEventMin)
        .data('ray', rayData )
        .data( 'mouseCoord', mouseCoord )
        .scope(this.editorModel.scope());

   return this.stateMachine.handle(cEvent);
};
